import { FC } from 'react';
import Icon, { IconNames } from 'components/Icon';
import colors from 'constants/colors';
import { AllocationTable } from '../AllocationTable';

export const WeightedAllocationTable: FC = () => (
  <AllocationTable
    className="weighted-allocation-table"
    renderInputControl={(group, onGroupChange) => (
      <div className="allocation-input-wrapper">
        <input
          type="number"
          className="allocation-input"
          value={group.weight_percent ?? 0}
          min={10}
          max={100}
          step={5}
          onChange={e => onGroupChange({ weight_percent: parseInt(e.target.value, 10) || 0 })}
          onBlur={e =>
            onGroupChange({
              weight_percent: Math.max(10, Math.min(100, parseInt(e.target.value, 10) || 10)),
            })
          }
        />
        <span className="oath-bodysmall inkBlue allocation-input-symbol">%</span>
        <div className="allocation-input-spinners">
          <button
            type="button"
            onClick={() =>
              onGroupChange({ weight_percent: Math.min(100, (group.weight_percent || 0) + 5) })
            }
          >
            <Icon name={IconNames.ChevronUp} color={colors.gray} size={10} />
          </button>
          <button
            type="button"
            onClick={() =>
              onGroupChange({ weight_percent: Math.max(10, (group.weight_percent || 0) - 5) })
            }
          >
            <Icon name={IconNames.ChevronDown} color={colors.gray} size={10} />
          </button>
        </div>
      </div>
    )}
  />
);
